<template>
  <div class="idCardUploadWay-container">
    <div class="idCardUploadWay-title">请选择上传方式</div>
    <div class="idCardUploadWay-floor-btn camera-btn" @click="selectCamera">
      开始拍摄
    </div>
    <div class="idCardUploadWay-floor-btn photo-btn" @click="selectPhoto">
      从相册上传
    </div>
  </div>
</template>
  <script>
export default {
  name: "idCardUploadWay",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    selectCamera() {
      this.$emit("doComfirm");
    },
    selectPhoto() {
      this.$emit("doCancel");
    },
  },
};
</script>
  <style >
.idCardUploadWay-container {
  background: #fff;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
}
.idCardUploadWay-title {
  font-size: 0.5rem;
  /* padding: 0.5rem 0; */
  margin-bottom: 0.5rem;
}
.idCardUploadWay-floor-btn {
  width: 100%;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.46rem;
  border-radius: 5px;
}
.camera-btn {
  background-color: #3c6cb4;
  color: #fff;
}
.photo-btn {
  margin-top: 0.5rem;
  border: 1px solid #3c6cb4;
  color: #3c6cb4;
}
</style>
